var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"communication-type-icon"},[(
            !_vm.journalEntry.communication_type ||
            _vm.journalEntry.communication_type === _vm.ECommunicationType.none
        )?_c('span',{staticClass:"text-info fa-stack"},[_c('i',{staticClass:"fal fa-fw fa-stack-1x"})]):_vm._e(),_vm._v(" "),(
            _vm.journalEntry.communication_type ===
            _vm.ECommunicationType.incoming_email
        )?_c('span',{staticClass:"text-success"},[_c('i',{staticClass:"fas fa-envelope"}),_vm._v(" "),_c('i',{staticClass:"fas fa-chevron-right"})]):_vm._e(),_vm._v(" "),(
            _vm.journalEntry.communication_type ===
            _vm.ECommunicationType.outgoing_email
        )?_c('span',{staticClass:"text-info"},[_c('i',{staticClass:"fas fa-chevron-left"}),_vm._v(" "),_c('i',{staticClass:"fas fa-envelope"})]):_vm._e(),_vm._v(" "),(
            _vm.journalEntry.communication_type ===
            _vm.ECommunicationType.incoming_direct_message
        )?_c('span',{staticClass:"text-success"},[_c('i',{staticClass:"fal fa-bell"}),_vm._v(" "),_c('i',{staticClass:"fal fa-chevron-left"})]):_vm._e(),_vm._v(" "),(
            _vm.journalEntry.communication_type ===
            _vm.ECommunicationType.outgoing_direct_message
        )?_c('span',{staticClass:"text-info"},[_c('i',{staticClass:"fal fa-bell"}),_vm._v(" "),_c('i',{staticClass:"fal fa-chevron-right"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }